/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_CopiedInputs */



/**
* | output |
* | --- |
* | "Decklist copied to clipboard" |
*
* @param {Deck_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_copied = /** @type {((inputs?: Deck_CopiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_CopiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste de deck copiée dans le presse-papier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de mazo copiada al portapapeles")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Lista de deck copiada para a área de transferência")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lista del mazzo copiata negli appunti")
	return /** @type {LocalizedString} */ ("Decklist copied to clipboard")
});